module.exports = __webpack_public_path__ + "static/media/Bar_Cocktails-right.7f943647.jpg";